import { useEffect, useState } from "react";
import { CustomAxios } from "@shared/api/axiosClient";

// Hook legado para componentes que no usan TanStack Query todavía.
// Los headers de auth los agrega el interceptor de axios; no se pasa Config() a mano.
export const useUserProfile = (isLoading?: () => void, isLoaded?: () => void) => {
    const [userData, setUserData] = useState<unknown>();
    const [isReady, setReady] = useState(false);

    useEffect(() => {
        if (isReady)
            return;

        if (isLoading && typeof isLoading === 'function')
            isLoading();

        CustomAxios.get("user-profile")
            .then(({ data }) => setUserData(data))
            .finally(() => {
                if (isLoaded && typeof isLoaded === 'function')
                    isLoaded();

                setReady(true);
            });
    }, [isLoading, isLoaded, userData, setUserData, isReady, setReady]);

    return { userData, isReady };
};
